// ============================================================
// Datei: src/pages/Impressum.jsx
// PURPOSE:
// Rechtlich notwendiges Impressum nach Schweizer Recht
// Betreiber: Festival des Arcs
// ============================================================

import React from "react";
import "../styles/impressum.css";
import "../styles/login.css"; // notwendig für bg-reveal

const Impressum = () => {
	return (
		<div
			className="impressum-container bg-reveal"
			data-bg={`${process.env.PUBLIC_URL}/backgrounds/background_impressum.png`}
		>
			<div className="impressum-card">

				{/* ============================================================
				   TITEL
				   ============================================================ */}
				<h1 className="impressum-title">Impressum</h1>

				<p>
					Dieses Webportal dient der Organisation und Verwaltung der
					freiwilligen Helferinnen und Helfer des
					<strong> Festival des Arcs</strong>.
				</p>


				{/* ============================================================
				   VERANTWORTLICHER BETREIBER
				   ============================================================ */}
				<section className="impressum-section">
					<h2>Betreiber der Plattform</h2>
					<p>
						<strong>Festival des Arcs</strong><br />
						Schweiz
					</p>
				</section>


				{/* ============================================================
				   KONTAKT
				   ============================================================ */}
				<section className="impressum-section">
					<h2>Kontakt</h2>
					<p>
						E-Mail:{" "}

						<a href="mailto:helfen@festivaldesarcs.ch">
							helfen@festivaldesarcs.ch
						</a><br />
						Website:{" "}
						<a href="https://festivaldesarcs.ch" target="_blank" rel="noreferrer">
							festivaldesarcs.ch
						</a>
					</p>
				</section>


				{/* ============================================================
				   DATENSCHUTZVERANTWORTLICHER
				   ============================================================ */}
				<section className="impressum-section">
					<h2>Datenschutz-Verantwortlicher (revDSG)</h2>
					<p>
						Verantwortlich für die Bearbeitung personenbezogener Daten:<br />
						<strong>Festival des Arcs</strong><br />
						E-Mail:{" "}

						<a href="mailto:helfen@festivaldesarcs.ch">
							helfen@festivaldesarcs.ch
						</a>
					</p>
				</section>


				{/* ============================================================
				   TECHNISCHE UMSETZUNG
				   ============================================================ */}
				<section className="impressum-section">
					<h2>Technische Umsetzung</h2>
					<p>
						Frontend: React.js<br />
						Backend: Java Spring Boot<br />
						Hosting: Infomaniak Public Cloud (Kubernetes Cluster, Schweiz)<br />
						Datenhaltung: Persistente Cloud Storage Systeme (Infomaniak)
					</p>
				</section>


				{/* ============================================================
				   HAFTUNGSAUSSCHLUSS
				   ============================================================ */}
				<section className="impressum-section">
					<h2>Haftungsausschluss</h2>
					<p>
						Die Inhalte dieser Webseite werden mit grösster Sorgfalt erstellt.
						Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte kann
						jedoch keine Gewähr übernommen werden.
						Der Betreiber übernimmt keine Haftung für Schäden, die durch die
						Nutzung dieser Webapplikation entstehen.
					</p>
				</section>


				{/* ============================================================
				   URHEBERRECHT
				   ============================================================ */}
				<section className="impressum-section">
					<h2>Urheberrecht</h2>
					<p>
						Sämtliche Inhalte dieser Webseite sind urheberrechtlich geschützt.
						Jede Verwendung ausserhalb der engen Grenzen des Urheberrechts
						bedarf der vorherigen schriftlichen Zustimmung des Betreibers.
					</p>
				</section>

			</div>
		</div>
	);
};

export default Impressum;